
import { GraficosProps } from '../../../containers/pages/Dashboard';
import {
  CATEGORIA_REQUEST,
  CATEGORIA_SUCCESS,
  CATEGORIA_FAIL
} from '../../actions/Dashboard/types';

// Define el tipo para el estado inicial
interface DatosInventarioState {
  categoriaDashboard: GraficosProps[];
}
// Estado inicial tipado
const initialState: DatosInventarioState = {
  categoriaDashboard: [],
};

// Reducer con tipos definidos
const categoriaReducers = (state = initialState, action: any) => {
  switch (action.type) {
    case CATEGORIA_REQUEST:
      return { ...state, loading: true };
    case CATEGORIA_SUCCESS:
      return {
        ...state,
        loading: false,
        categoriaDashboard: action.payload,
      };
    case CATEGORIA_FAIL:
      return { ...state, loading: false, error: action.error };
    default:
      return state;
  }
};



export default categoriaReducers;
